import { z } from 'zod';

import {
  AI_MODEL_CHOICE_OPTIONS,
  LANGUAGE_ENCODING_OPTIONS,
  LVLM_PERFORMANCE_MODES,
  LVLM_USAGE,
} from '../constants';
import { zodAiModelEntrySchema } from '../validations';

const zodAiModelSettingsSchema = z.object({
  aiModels: z.union([z.array(zodAiModelEntrySchema), z.string()]),
  diPlusAiFoundryFieldsToReplace: z.array(z.string()).nullish(),
  languageEncoding: z.enum(LANGUAGE_ENCODING_OPTIONS).nullish(),
  lvlmPerformanceMode: z.enum(LVLM_PERFORMANCE_MODES),
  lvlmUsage: z.enum(LVLM_USAGE),
  modelChoice: z.enum(AI_MODEL_CHOICE_OPTIONS).nullable(),
  processBulk: z.string().nullish(),
});

const zodInvoiceSenderSchema = z.object({
  companyDomain: z.string().nullish(),
  createdOn: z.iso.datetime({ offset: true }),
  id: z.uuid(),
  modifiedOn: z.iso.datetime({ offset: true }).nullish(),
  senderAddress: z.string().nullish(),
});

export const zodInvoiceAiModelSettingsResponseSchema = z.object({
  aiModelSettings: zodAiModelSettingsSchema,
  createdOn: z.iso.datetime({ offset: true }),
  id: z.uuid(),
  modifiedOn: z.iso.datetime({ offset: true }).optional(),
  senders: z.array(zodInvoiceSenderSchema),
});
